/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/loading"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

// ✅ UPDATED: Stronger, broader subtitle matching all 3 CVs
const greeting = {
  username: "Muhammad Hamza",
  title: "Hi, I'm Hamza",
  subTitle: emoji(
    "Flutter & Full-Stack Engineer 🚀 specialising in mobile, AI systems, and production backends — with nearly 5 years of experience shipping apps with 10M+ downloads, real-time robotics platforms, and end-to-end RAG pipelines."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ShJkKfmf_5OEDb0oGV70c2K-aKdigwaJ/view?usp=sharing", // ⚠️ Update this to your latest CV link
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/HamzaDsu",
  linkedin: "https://www.linkedin.com/in/shaikhmuhammadhamza/",
  gmail: "muhammadhamza.ghulam@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Flutter & Full-Stack Engineer with hands-on AI integration experience",
  skills: [
    emoji(
      "⚡ Build production-grade cross-platform apps in Flutter (Clean Architecture, BLoC, Riverpod) and native Android (Jetpack Compose, Kotlin, MVVM) — contributed to apps with 10M+ downloads."
    ),
    emoji(
      "⚡ Engineer scalable backends using Node.js, TypeScript, FastAPI, and Express — with layered architecture, transactional logic, and REST API design for production AI platforms."
    ),
    emoji(
      "⚡ Architect AI-powered document pipelines using Celery, Redis, pgvector, LangChain, and OpenAI SDK — including async OCR, vector embeddings, and full RAG workflows."
    ),
    emoji(
      "⚡ Integrate real-time computer vision and gesture detection using Python, OpenCV, and TensorFlow — including embedded systems and hardware-in-the-loop applications."
    ),
    emoji(
      "⚡ Automate CI/CD pipelines using GitLab CI/CD and Fastlane, and deploy using Docker, Firebase, GCP, and AWS."
    ),
  ],

  softwareSkills: [
    // ── Mobile ──────────────────────────────────────
    {
      skillName: "Flutter",
      fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "Dart",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "Kotlin",
      fontAwesomeClassname: "fab fa-korvue"
    },
    {
      skillName: "Jetpack Compose",
      fontAwesomeClassname: "fab fa-android"
    },
    // ✅ ADDED: State management libs missing from original
    {
      skillName: "BLoC / Riverpod",
      fontAwesomeClassname: "fas fa-layer-group"
    },
    // ✅ ADDED: Dagger Hilt (from Android CV)
    {
      skillName: "Dagger Hilt",
      fontAwesomeClassname: "fas fa-syringe"
    },
    // ── Frontend ─────────────────────────────────────
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    // ✅ ADDED: Next.js (from Full-Stack CV)
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fas fa-forward"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-code"
    },
    // ── Backend ──────────────────────────────────────
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "fas fa-bolt"
    },
    // ✅ ADDED: Redis and Celery (from all 3 CVs)
    {
      skillName: "Redis / Celery",
      fontAwesomeClassname: "fas fa-server"
    },
    // ── AI / ML ──────────────────────────────────────
    // ✅ ADDED: LangChain (from all 3 CVs)
    {
      skillName: "LangChain",
      fontAwesomeClassname: "fas fa-link"
    },
    {
      skillName: "OpenCV",
      fontAwesomeClassname: "fas fa-eye"
    },
    // ✅ ADDED: Scikit-learn (from Full-Stack CV)
    {
      skillName: "Scikit-learn",
      fontAwesomeClassname: "fas fa-brain"
    },
    // ── Database ─────────────────────────────────────
    {
      skillName: "PostgreSQL / pgvector",
      fontAwesomeClassname: "fas fa-database"
    },
    // ── DevOps / Cloud ───────────────────────────────
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    // ✅ ADDED: GCP (from all 3 CVs)
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    },
    // ✅ ADDED: GitLab CI/CD (from all 3 CVs)
    {
      skillName: "GitLab CI/CD",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    // ✅ ADDED: Fastlane (from all 3 CVs)
    {
      skillName: "Fastlane",
      fontAwesomeClassname: "fas fa-rocket"
    },
    {
      skillName: "GitHub",
      fontAwesomeClassname: "fab fa-github"
    },
    // ── Architecture ─────────────────────────────────
    {
      skillName: "Clean Architecture / MVVM",
      fontAwesomeClassname: "fas fa-sitemap"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Brandenburgische Technische Universität",
      logo: require("./assets/images/btu.png"),
      subHeader: "Master of Science in Artificial Intelligence",
      duration: "2023 - 2026",
      descBullets: [
        "Focus on Machine Learning, LLMs, Computer Vision, and Intelligent System Design",
      ]
    },
    {
      schoolName: "DHA Suffa University",
      logo: require("./assets/images/dhasuffa5.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2017 - 2021",
      descBullets: ["Focus on Data Structures, Software Engineering, Mobile Technologies, Database Systems, and OOP"]
    }
  ]
};

const techStack = {
  viewSkillBars: false,
  experience: [
    {
      Stack: "Flutter & Mobile Development",
      progressPercentage: "90%",
      description: "Nearly 5 years building production Flutter and Android apps. Contributed to products with 10M+ downloads using Clean Architecture, BLoC, Riverpod, Jetpack Compose, and Kotlin."
    },
    {
      Stack: "Backend & API Engineering",
      progressPercentage: "80%",
      description: "Built production backends with Node.js/TypeScript and FastAPI — layered architecture, transactional logic, REST APIs, Celery async pipelines, and Redis queuing."
    },
    {
      Stack: "AI & RAG Systems",
      progressPercentage: "75%",
      description: "Architected end-to-end RAG pipelines using pgvector, LangChain, and OpenAI SDK. Built async document ingestion with OCR, vector embeddings, and agentic workflows."
    },
    {
      Stack: "Computer Vision & Python",
      progressPercentage: "70%",
      description: "Trained and deployed gesture detection models using OpenCV and TensorFlow in a real-time robotics context. Also applied Python for data pipelines and ML experimentation."
    },
    {
      Stack: "Architecture & State Management",
      progressPercentage: "88%",
      description: "Deep experience with Clean Architecture, MVVM, MVP, BLoC, and Riverpod. Applied SOLID principles and GOF patterns across mobile, backend, and cross-platform projects."
    },
  ],
  displayCodersrank: true
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Flutter & Full Stack Engineer",
      company: "EKM GmbH",
      companylogo: require("./assets/images/ekm.png"),
      companyUrl: "https://www.ekm.de/",
      date: "Oct 2025 – Feb 2026",
      descBullets: [
        "Engineered a Flutter frontend using Clean Architecture and Riverpod for AI agent configuration, document management, and encrypted state handling.",
        "Developed a production-grade Node.js/TypeScript backend with layered architecture (Controller–Service–Repository), transactional logic, and centralised error handling.",
        "Architected async document pipelines using FastAPI, Celery, Redis, and pgvector, enabling OCR, vector embeddings, and scalable RAG workflows.",
        // ✅ ADDED: Missing bullet from CV
        "Integrated third-party APIs and external systems to extend platform functionality and support evolving product requirements.",
        "Implemented automated unit and integration test suites across every deployment cycle."
      ]
    },
    {
      role: "Software Engineer",
      company: "GoodBot GmbH",
      companylogo: require("./assets/images/goodbot4.png"),
      companyUrl: "https://www.goodbot.de/",
      date: "Apr 2024 – Oct 2025",
      descBullets: [
        "Built a Flutter desktop application for a next-gen robotic pipetting system with real-time hardware control and low-latency communication between software and embedded systems.",
        "Led end-to-end development of key Flutter modules from scratch, working independently with minimal specs.",
        "Designed and trained computer vision models for gesture detection using OpenCV and TensorFlow, enabling intuitive real-time robot interaction.",
        // ✅ ADDED: Missing bullet from CV
        "Developed and maintained backend services and additional software tooling to support platform reliability and internal workflows.",
        // ✅ ADDED: Missing bullet from CV
        "Integrated external systems and APIs to extend platform functionality in collaboration with cross-functional hardware and data teams.",
        "Implemented automated unit and integration tests to ensure code quality and stability across every release cycle."
      ]
    },
    {
      role: "Associate Software Engineer",
      company: "VentureDive",
      companylogo: require("./assets/images/venturedive4.jpeg"),
      companyUrl: "https://www.venturedive.com/",
      date: "Feb 2021 – Jan 2024",
      descBullets: [
        "Developed and maintained Android-native features for high-traffic applications reaching 10M+ downloads using Kotlin, MVVM, Jetpack Compose, Dagger Hilt, and Kotlin Coroutines.",
        // ✅ ADDED: Missing bullet from CV
        "Delivered core features including real-time tracking, REST API integration via Retrofit/OkHttp, and push notifications using Firebase FCM across multiple production apps.",
        "Built and scaled Flutter applications using BLoC and Firebase-backed real-time features, reaching 100K+ downloads.",
        "Migrated legacy MVP architecture codebases to MVVM, improving maintainability and aligning with modern Android best practices.",
        // ✅ ADDED: Missing bullet from CV
        "Wrote unit and integration tests using JUnit, Mockito, and Espresso to maintain code quality across release cycles.",
        "Automated release pipelines using GitLab CI/CD and Fastlane across Android and iOS targets."
      ]
    },
    {
      role: "Flutter Engineer",
      company: "DigiBytes",
      companylogo: require("./assets/images/cstech.jpeg"),
      companyUrl: "https://digibytes.pk/",
      date: "Nov 2020 – Jan 2021",
      descBullets: [
        "Developed and maintained Flutter applications, implementing responsive UI designs and smooth user interactions across platforms.",
        "Integrated RESTful APIs for dynamic content, user authentication, and real-time data within mobile apps.",
        "Contributed to e-commerce feature development including product listing, cart management, and payment flow integration."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Production apps, AI platforms, and robotics — a cross-section of what I've shipped.",
  projects: [
    {
      // ✅ FIXED: Was using ekm.png — now using Anna.png (already fixed in your file)
      image: require("./assets/images/Anna.png"),
      projectName: "Anna — AI Chatbot & RAG Platform",
      projectDesc: "Built a full agentic RAG system with pgvector vector search, async document pipelines (OCR + embeddings) via Celery/Redis, and a React chat interface. FastAPI backend with LangChain and OpenAI SDK.",
    },
    {
      image: require("./assets/images/kimpany.png"),
      projectName: "Kimpany — AI Agent Platform",
      projectDesc: "Flutter frontend with Clean Architecture and Riverpod for AI agent configuration and encrypted document management. Node.js/TypeScript backend with layered architecture and transactional logic.",
    },
    {
      image: require("./assets/images/goodbot2.png"),
      projectName: "GoodBot — Pipetting Robot",
      projectDesc: "Flutter desktop app for a next-gen robotic pipetting system with real-time hardware control, low-latency embedded system communication, and gesture detection via OpenCV and TensorFlow.",
    },
    {
      image: require("./assets/images/athan.png"),
      projectName: "Athan",
      projectDesc: "Contributed to a top-rated Islamic app with 10M+ downloads — Jetpack Compose UI, Firebase features, and performance optimisations using Kotlin Coroutines and MVVM.",
      footerLink: [
        {
          name: "Play Store",
          url: "https://play.google.com/store/apps/details?id=com.athan&hl=en"
        }
      ]
    },
    {
      image: require("./assets/images/munchies5.png"),
      projectName: "Munchies",
      projectDesc: "Delivered core Android functionality for a high-traffic food delivery app — real-time order tracking, REST API integration via Retrofit, and push notifications. 500K+ downloads.",
      footerLink: [
        {
          name: "Link",
          url: "https://www.linkedin.com/company/munchieshome/about/"
        }
      ]
    },
    {
      image: require("./assets/images/athanacademy.png"),
      projectName: "Athan Academy",
      projectDesc: "Cross-platform Islamic learning app built with Flutter and BLoC. Firebase and REST API integration for interactive lessons and real-time progress tracking. 100K+ downloads.",
      footerLink: [
        {
          name: "Play Store",
          url: "https://play.google.com/store/apps/details?id=com.islamicfinder.alif&hl=en"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section

// ✅ UPDATED: Improved subtitle, kept existing certs, added MSc context
const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Certifications and completed courses in web, backend, and AI development",

  achievementsCards: [
    {
      title: "React.js Essential Training Certificate",
      subtitle: "Completed LinkedIn Learning course covering React.js fundamentals and DOM manipulation.",
      image: require("./assets/images/essential.png"),
      imageAlt: "LinkedIn Learning",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/learning/certificates/6b50873155e28cb5baa4102a61b8b00a6db42985e50fe755744c6e7df094401c"
        },
      ]
    },
    {
      title: "React.js Design Patterns",
      subtitle: "Completed LinkedIn Learning course on React.js design patterns and component lifecycle management.",
      image: require("./assets/images/design.png"),
      imageAlt: "LinkedIn Learning",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/learning/"
        }
      ]
    },
    {
      title: "Building a Website with Node.js and Express.js",
      subtitle: "Completed LinkedIn Learning course on server-side development with Node.js and Express.",
      image: require("./assets/images/express.png"),
      imageAlt: "LinkedIn Learning",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.linkedin.com/learning/certificates/82b42e5fd11112dd4984e063b19d8edd01f5f02d2b831f1243197bb0fc3cce50"
        },
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Open to Flutter, full-stack, and AI-focused roles — let's talk.",
  number: "+4915566441278",
  email_address: "muhammadhamza.ghulam@gmail.com"
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  educationInfo,
  contactInfo,
  resumeSection
};